import { IApiService } from '../interfaces/services/IApiService';
import { ApiRequestConfig, apiService } from './api.service';

import { IUser } from '@/interfaces/entities/user';
import { AccountStatus } from '@/interfaces/entities/user.account-status';

class UserService {
	api: IApiService<ApiRequestConfig>;

	constructor(api: IApiService<ApiRequestConfig>) {
		this.api = api;
	}

	async getAllUsers(
		pageNumber: number,
		pageSize: number,
		config?: ApiRequestConfig,
	) {
		return await this.api.get<{ data: IUser[]; pageCount: number }>(
			`/user/admin?page[size]=${pageSize}&page[number]=${pageNumber}`,
			config,
		);
	}

	async getFilterUsers(query?: string, config?: ApiRequestConfig) {
		return await this.api.get<{ data: IUser[] }>(`/user${query}`, config);
	}

	async getUserById(id: number, config?: ApiRequestConfig) {
		return await this.api.get<IUser>(`/user/${id}`, config);
	}

	async changeApplicationRequest(
		id: number,
		applicationRequest: AccountStatus,
		message: string,
		config?: ApiRequestConfig,
	) {
		const response = await this.api.patch(
			`/user/admin/user/${id}/status`,
			{ applicationRequest, message },
			config,
		);
		return response;
	}

	async getAllUsersIds(config?: ApiRequestConfig) {
		return await this.api.get<number[]>(`/user/all-ids`, config);
	}
}

export const userService = new UserService(apiService);
